import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import "../../../assets/css/admin/layout/AdminLayout.css";
import "../../../assets/css/admin/layout/AdminSidebar.css";
import "../../../assets/css/admin/layout/AdminHeader.css";
import "../../../assets/css/admin/cc/CcSidebar.css";
import "../../../assets/css/admin/cc/CcHeader.css";

import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import CcSidebar from "../cc/CcSidebar";
import CcHeader from "../cc/CcHeader";
import { getStoredAdminInfo } from "../AdminAuth";

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const accessToken = localStorage.getItem("accessToken");
  const { isStdCouncil, isCc, isAudit } = getStoredAdminInfo();

  const isUnitAdmin = isCc || isAudit;

  useEffect(() => {
    if (!accessToken) {
      navigate("/stdcounciladmin", {
        replace: true,
      });
    }
  }, [accessToken, navigate]);

  useEffect(() => {
    if (!accessToken) return;

    if (!isStdCouncil && !isUnitAdmin) {
      navigate("/stdcounciladmin", {
        replace: true,
      });
    }
  }, [accessToken, isStdCouncil, isUnitAdmin, navigate]);

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!sidebarOpen) return;

    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setSidebarOpen(false);
      }
    };

    window.addEventListener("keydown", handleEsc);

    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [sidebarOpen]);

  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = "hidden";
      return;
    }

    document.body.style.overflow = "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [sidebarOpen]);

  if (!accessToken) {
    return null;
  }

  if (!isStdCouncil && !isUnitAdmin) {
    return null;
  }

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="admin-layout">
      <button
        type="button"
        className="admin-mobile-menu-btn"
        onClick={() => setSidebarOpen(true)}
        aria-label="관리자 메뉴 열기"
        aria-expanded={sidebarOpen}
      >
        <span className="admin-mobile-menu-line" />
        <span className="admin-mobile-menu-line" />
        <span className="admin-mobile-menu-line" />
      </button>

      <aside className={`admin-sidebar-drawer ${sidebarOpen ? "is-open" : ""}`}>
        <button
          type="button"
          className="admin-sidebar-close-btn"
          onClick={closeSidebar}
          aria-label="관리자 메뉴 닫기"
        >
          ×
        </button>

        {isUnitAdmin ? <CcSidebar /> : <AdminSidebar />}
      </aside>

      <div className="admin-main">
        {isUnitAdmin ? <CcHeader /> : <AdminHeader />}

        <main className="admin-content">
          {isUnitAdmin ? (
            <Outlet />
          ) : (
            <div className="content-shell">
              <Outlet />
            </div>
          )}
        </main>
      </div>
    </div>
  );
}